import React from "react";
import styles from "../MegaMenu.css";
import AnimatedTitle from "./AnimatedTitle";
import AnimatedLink from "./AnimatedLink";

export const FADEIN_DELAY = 50;

export default function MegaMenuLinksSection({
  menu,
  activeMenuIndex,
  setActiveMenuIndex,
}) {
  let counter = 4; // In order to delay the animation till' the menu is open
  return (
    <div
      className={[styles.LinksSection, styles.LinksSection_thy].join(" ")}
      style={{
        opacity: activeMenuIndex !== undefined ? 1 : 0,
      }}
    >
      {activeMenuIndex !== undefined &&
        menu[activeMenuIndex].children.map((item, idx) => {
          counter = counter + 1;
          return (
            <div key={idx}>
              <AnimatedTitle
                title={item.title}
                count={counter}
                activeMenuIndex={activeMenuIndex}
              />
              <ul className={styles["LinksSection-Links"]}>
                {item.children.map((item, idx2) => {
                  counter = counter + 1;
                  return (
                    <li key={idx2}>
                      <AnimatedLink
                        url={item.url}
                        title={item.title}
                        setActiveMenuIndex={setActiveMenuIndex}
                        count={counter}
                        external={item.external}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header/Components/MegaMenu/Components/MegaMenuLinksSection.js